import dayjs from 'dayjs'

import { MinimalCompany } from '@/types/company'
import { LoadingListRoute } from '@/types/cargo-loading'

export function nameAndShortCodeString(name: string, shortCode: string | null): string {
    if (shortCode) {
        return `${name} (${shortCode})`
    }

    return name
}

interface ProviderInput {
    provider: MinimalCompany
    providerNumber: string
    providerAccountNumber: string | null
}

/**
 * Returns the full provider number, eg. CA43232
 * Expects either a loading list or a default remark
 * @param input
 */
export function fullProviderNumber(input: ProviderInput): string {
    return `${input.providerAccountNumber ?? input.provider.name}${input.providerNumber}`
}

export function formatRouteInfo(destination: string, route: LoadingListRoute): string {
    const date = route.departedAt
    const carrierString = `${route.carrierAccountNumber ?? route.carrier.name}${route.carrierNumber}`
    if (!date) return `${carrierString} / ${destination}`

    const dateFormatted = dayjs(date).format('DDMMMYYYY').toUpperCase()
    return `${carrierString} / ${dateFormatted} ${destination}`
}
